import { ApiProperty } from '@nestjs/swagger';
import { PurposeEnum, StatusEnum } from '@needle-management/shared-models';
export class MaterialRequestDTO {

  @ApiProperty()
  materialReqId: number;

  @ApiProperty()
  date: Date;

  @ApiProperty()
  module: string; 

  @ApiProperty()
  shift: string; 

  @ApiProperty()
  machineTypeId: number; 

  @ApiProperty()
 needleModelId : number; 

  @ApiProperty()
  needleSizeId: number; 

  @ApiProperty()
  needleQuantity: string; 

  @ApiProperty()
  purpose: PurposeEnum; 


  @ApiProperty()
  isActive: boolean;

  @ApiProperty()
  createdAt : Date;

  @ApiProperty()
  createdUser : string;
  
  @ApiProperty()
  updatedAt : Date;

  @ApiProperty()
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

 @ApiProperty()
  stockInId : number;

 @ApiProperty()
  needlePointId:number;

  @ApiProperty()
  mechanicName:string
}

